const getPageSize = (size: number, totalPage: number) => {
  if (totalPage === 1) {
    return size
  }
  return size < 10 && size > 0 ? 10 : size
}

const parsePageLinks = (page: any) => {
  const totEle = +page?.totalElements ?? 0
  const totPage = totEle < 11 ? 0 : +page?.totalPages ?? 0
  const pageNumber = totEle < 11 ? 0 : +page?.number ?? 0
  const pgSize = getPageSize(+page?.size ?? 0, totPage)
  return {
    size: pgSize,
    totalElements: +page?.totalElements ?? 0,
    totalPages: totPage,
    number: pageNumber,
  }
}

const bulkRefundsParser = (data: any, pageNumber: number): any => {
  const { fileList } = data
  const pageData = {
    size: fileList?.length ?? 0,
    totalElements: data?.totalElements ?? 0,
    totalPages: Math.floor(data?.totalElements / 10) ?? 0,
    number: pageNumber ?? 0,
  }
  const pagination = parsePageLinks(pageData)

  const bulkRefunds =
    fileList?.map((bulkRefund: any) => ({
      id: `${bulkRefund?.fileId ?? ''}`,
      fileName: bulkRefund?.fileName ?? 'NA',
      createdAt: bulkRefund?.createdAt?.split('T')[0] ?? '',
      count: bulkRefund?.recordCount ?? 0,
      totalRefundAmount: bulkRefund?.totalRefundAmount ?? 0,
      accepted: bulkRefund?.accepted ?? 0,
      successAmount: bulkRefund?.successAmount ?? 0,
      declined: bulkRefund?.declined ?? 0,
      failureAmount: bulkRefund?.failureAmount ?? 0,
      updatedAt: bulkRefund?.updatedAt ?? '',
      status: bulkRefund?.fileStatus ?? '',
    })) ?? []

  return { files: bulkRefunds, page: pagination }
}

export { bulkRefundsParser }
